export const environment = {
  production: true,
  apiUrl: window.location.origin,
};
